'use strict';

/**
 *  Load modules
 */
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import '../scss/app.scss';
/**
 * Header functionality
 */
document.addEventListener('DOMContentLoaded', function () {
  // fixed header
  function fixedHeader() {
    if (window.scrollY > 84) {
      document.querySelector('.header').classList.add('header--fixed');
    } else {
      document.querySelector('.header').classList.remove('header--fixed');
    }
  }

  // Виклик при завантаженні сторінки
  fixedHeader();

  // Виклик при скролі
  window.addEventListener('scroll', fixedHeader);

  // Search toggle functionality
  var searchToggle = document.querySelector('.header__search-toggle');
  var searchWrapper = document.querySelector('.header__search-form-wrapper');
  var searchInput = document.querySelector('.header__search-input');
  var searchClose = document.querySelector('.header__search-close');
  if (searchToggle && searchWrapper && searchInput) {
    // Toggle search form
    searchToggle.addEventListener('click', function (e) {
      e.preventDefault();
      var isActive = searchWrapper.classList.toggle('header__search-form-wrapper--active');

      // Accessibility
      searchWrapper.hidden = !isActive;
      searchToggle.setAttribute('aria-expanded', isActive);

      // Focus input when opening
      if (isActive) {
        setTimeout(function () {
          searchInput.focus();
        }, 100);
      }
    });

    // Close search on ESC key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchWrapper.classList.contains('header__search-form-wrapper--active')) {
        searchWrapper.classList.remove('header__search-form-wrapper--active');
        searchWrapper.hidden = true;
        searchToggle.setAttribute('aria-expanded', 'false');
        searchToggle.focus(); // повертаємо фокус на toggle
      }
    });

    // Close search when clicking outside
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.header__search') && searchWrapper.classList.contains('header__search-form-wrapper--active')) {
        searchWrapper.classList.remove('header__search-form-wrapper--active');
        searchWrapper.hidden = true;
        searchToggle.setAttribute('aria-expanded', 'false');
      }
    });

    // Close search on close button click
    if (searchClose) {
      searchClose.addEventListener('click', function (e) {
        e.preventDefault();
        searchWrapper.classList.remove('header__search-form-wrapper--active');
        searchWrapper.hidden = true;
        searchToggle.setAttribute('aria-expanded', 'false');
        searchToggle.focus();
      });
    }
  }

  // Dynamic search wrapper width
  function updateSearchWidth() {
    if (window.innerWidth < 961) {
      if (searchWrapper) searchWrapper.style.width = '';
      return;
    }
    var headerRow = document.querySelector('.header__row');
    var logo = document.querySelector('.header__logo');
    var btns = document.querySelector('.header__btns');
    if (!headerRow || !logo || !btns || !searchWrapper) return;
    var width = headerRow.offsetWidth - logo.offsetWidth - btns.offsetWidth - 104;
    searchWrapper.style.width = width + 'px';
  }
  updateSearchWidth();
  window.addEventListener('resize', updateSearchWidth);

  // Mobile menu functionality
  var mobileToggle = document.querySelector('.header__mobile-btn');
  var navigation = document.querySelector('.header__navigation');
  if (mobileToggle && navigation) {
    mobileToggle.addEventListener('click', function (e) {
      e.preventDefault();
      navigation.classList.toggle('header__navigation--active');
      mobileToggle.classList.toggle('header__mobile-btn--active');

      // Toggle aria-expanded
      var isExpanded = mobileToggle.getAttribute('aria-expanded') === 'true';
      mobileToggle.setAttribute('aria-expanded', !isExpanded);
    });

    // Close mobile menu on ESC
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && navigation.classList.contains('header__navigation--active')) {
        navigation.classList.remove('header__navigation--active');
        mobileToggle.classList.remove('header__mobile-btn--active');
        mobileToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // footer menu
  var parentLinks = document.querySelectorAll('.footer__column-title');
  parentLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      if (window.innerWidth > 767) return; // тільки для екранів <= 767px
      e.preventDefault();
      var submenu = link.nextElementSibling;
      if (submenu && submenu.classList.contains('footer__toggle')) {
        var isOpen = submenu.classList.contains('is-open');

        // Закриваємо
        if (isOpen) {
          submenu.style.height = submenu.scrollHeight + 'px';
          requestAnimationFrame(function () {
            submenu.style.height = '0px';
          });
          submenu.classList.remove('is-open');
          link.classList.remove('open');
        } else {
          // Відкриваємо
          submenu.style.display = 'block';
          submenu.style.height = 'auto';
          var height = submenu.scrollHeight + 'px';
          submenu.style.height = '0px';
          requestAnimationFrame(function () {
            submenu.style.height = height;
          });
          submenu.classList.add('is-open');
          link.classList.add('open');
        }

        // Після анімації — чистимо inline style
        submenu.addEventListener('transitionend', function handler() {
          if (submenu.classList.contains('is-open')) {
            submenu.style.height = 'auto';
          } else {
            submenu.style.display = 'none';
          }
          submenu.style.transition = '';
          submenu.removeEventListener('transitionend', handler);
        });
      }
    });
  });

  // --- Scroll buttons for tabs ---
  var $tabsWrapper = $(".tabs-wrapper");
  var $tabs = $tabsWrapper.find(".tabs");
  var $tabItems = $tabs.find(".tab__item");
  if ($tabsWrapper.length) {
    var updateScrollButtons = function updateScrollButtons() {
      var scrollLeft = _$tabs.scrollLeft();
      var maxScroll = _$tabs[0].scrollWidth - _$tabs.outerWidth();
      $leftBtn.toggle(scrollLeft > 10);
      $rightBtn.toggle(scrollLeft < maxScroll - 10);
    };
    // перевіряємо, чи є елемент
    var _$tabs = $tabsWrapper.find(".tabs");
    var $leftBtn = $('<button type="button" class="tabs__scroll-btn tabs__scroll-btn--left"></button>');
    var $rightBtn = $('<button type="button" class="tabs__scroll-btn tabs__scroll-btn--right"></button>');
    $tabsWrapper.append($leftBtn).append($rightBtn);
    $leftBtn.on("click", function () {
      var $current = $tabItems.filter(".active");
      var $prev = $current.prev(".tab__item");
      if ($prev.length) $prev.trigger("click");
    });
    $rightBtn.on("click", function () {
      var $current = $tabItems.filter(".active");
      var $next = $current.next(".tab__item");
      if ($next.length) $next.trigger("click");
    });
    $leftBtn.on("click", function () {
      return _$tabs.animate({
        scrollLeft: "-=50"
      }, 300);
    });
    $rightBtn.on("click", function () {
      return _$tabs.animate({
        scrollLeft: "+=50"
      }, 300);
    });
    _$tabs.on("scroll", updateScrollButtons);
    $(window).on("resize", updateScrollButtons);
    updateScrollButtons();
  }

  /* search form */
  var input = document.getElementById('rst-hero-keyword');
  var clearBtn = document.querySelector('.rst-hero-search__btn--clear');
  if (input && clearBtn) {
    var toggleClearBtn = function toggleClearBtn() {
      if (input.value && input.value.trim().length > 0) {
        clearBtn.classList.add('visible'); // або .show
      } else {
        clearBtn.classList.remove('visible');
      }
    };

    // Основні події
    input.addEventListener('input', toggleClearBtn);
    input.addEventListener('change', toggleClearBtn);
    input.addEventListener('keyup', toggleClearBtn);

    // Для автозаповнення (Chrome, Safari)
    input.addEventListener('focus', function () {
      setTimeout(toggleClearBtn, 100);
    });

    // fallback — перевірка значення (autocomplete, back/forward cache)
    var interval = setInterval(toggleClearBtn, 300);

    // (опційно) зупинити interval коли не треба
    input.addEventListener('blur', function () {
      setTimeout(function () {
        return clearInterval(interval);
      }, 2000);
    });

    // кнопка очищення
    clearBtn.addEventListener('click', function () {
      input.value = '';
      input.focus();
      toggleClearBtn();
    });

    // первинна ініціалізація
    toggleClearBtn();
  }

  // ===== POPUPS =====
  var $popup = $('.popup');
  var lastFocusedElement = null;

  // Закрити попап
  function closePopup() {
    $popup.removeClass('open').attr('hidden', true);
    FocusTrap.deactivate();
  }

  // Клік на фон або хрестик
  $('.popup__close, .popup__bg').on('click', function () {
    closePopup();
  });

  // ESC
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') closePopup();
  });
});
function fixAllSlickDisabledFocus() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  context.querySelectorAll('.slick-arrow').forEach(function (btn) {
    var isDisabled = btn.classList.contains('slick-disabled');
    if (isDisabled) {
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('tabindex', '-1');
      btn.setAttribute('aria-disabled', 'true');
    } else {
      btn.removeAttribute('disabled');
      btn.removeAttribute('tabindex');
      btn.setAttribute('aria-disabled', 'false');
    }
  });
}
$(document).on('init reInit afterChange', '.slick-slider', function () {
  fixAllSlickDisabledFocus(this);
});

// ===== UNIVERSAL FOCUS TRAP FOR POPUPS =====
// focus-trap.js (глобальний файл)
window.FocusTrap = function () {
  var focusableSelector = "\n    a[href],\n    area[href],\n    input:not([disabled]):not([type=\"hidden\"]),\n    select:not([disabled]),\n    textarea:not([disabled]),\n    button:not([disabled]),\n    iframe,\n    object,\n    embed,\n    [contenteditable],\n    [tabindex]:not([tabindex=\"-1\"])\n  ";
  var lastFocusedElement = null;
  var removeListener = null;
  function trap(popup) {
    var content = popup.querySelector('.popup__content') || popup;
    function getFocusable() {
      return _toConsumableArray(content.querySelectorAll(focusableSelector)).filter(function (el) {
        return el.offsetParent !== null;
      });
    }
    function onKeydown(e) {
      if (e.key !== 'Tab') return;
      var focusable = getFocusable();
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
    popup.addEventListener('keydown', onKeydown);
    removeListener = function removeListener() {
      return popup.removeEventListener('keydown', onKeydown);
    };
  }
  return {
    activate: function activate(popup) {
      if (!popup) return;
      lastFocusedElement = document.activeElement;
      trap(popup);
    },
    deactivate: function deactivate() {
      if (removeListener) removeListener();
      removeListener = null;
      if (lastFocusedElement) {
        lastFocusedElement.focus();
        lastFocusedElement = null;
      }
    }
  };
}();